import React from 'react';
import styled from 'styled-components';
import { Card, CardActionArea, CardMedia, CardContent, Typography } from '@material-ui/core';

import theme from 'meta/theme';
import { CustomLink } from 'components';

const FeatureCard = styled(Card)`
	background: ${theme.palette.primary.main};

	.MuiCardContent-root {
		min-height: 130px;
	}

	&&&&& > * {
		text-decoration: none;
	}
`;

const ImageCard = ({
	title,
	desc,
	image,
	link
}: {
	title: string;
	desc: string | React.ReactNode;
	image: string;
	link?: string;
}) => (
	<FeatureCard>
		{link ? (
			<CustomLink to={link}>
				<CardActionArea>
					<CardMedia className="pixelated" component="img" height="140" image={image} />
					<CardContent>
						<Typography gutterBottom variant="h5" component="h2">
							{title}
						</Typography>
						<Typography variant="body2" color="textSecondary" component="p">
							{desc}
						</Typography>
					</CardContent>
				</CardActionArea>
			</CustomLink>
		) : (
			<>
				<CardMedia className="pixelated" component="img" height="140" image={image} />
				<CardContent>
					<Typography gutterBottom variant="h5" component="h2">
						{title}
					</Typography>
					<Typography variant="body2" color="textSecondary" component="p">
						{desc}
					</Typography>
				</CardContent>
			</>
		)}
	</FeatureCard>
);

export default ImageCard;
